import React, { FunctionComponent } from "react";
import { IProps } from "./ellipsis-menu-provider.types";
import EllipsisMenuContext, { defaultContext } from "../ellipsis-menu-context/ellipsis-menu-context";

const EllipsisMenuProvider: FunctionComponent<IProps> = ({ children, context }) => (
    <EllipsisMenuContext.Provider value={{ ...defaultContext, ...context }}>{children}</EllipsisMenuContext.Provider>
);

export default EllipsisMenuProvider;
